/** Общие правила мини-игр второго шанса. */

export const CLAUDI_PAIR_PREVIEW_MS = 2000 as const;
/** Лимит времени на подбор пар после превью (сек). */
export const CLAUDI_PAIR_TIME_LIMIT_SEC = 30 as const;
/** Экран успеха после победы в «Найди пару», затем продолжение забега. */
export const CLAUDI_VICTORY_HOLD_MS = 3000 as const;
export const CLAUDI_PAIR_COUNT = 3 as const;
/** Длина мелодии / число ячеек («Заполни 6 ячеек нотами» в mini-game3.svg). */
export const TUCHI_MELODY_LENGTH = 6 as const;
/** Число нот-кнопок (note1…note4 в .dev/tuchi). */
export const TUCHI_NOTE_COUNT = 4 as const;
/** Лимит времени «Собери мелодию» (сек), как в mini-game3.svg. */
export const TUCHI_MELODY_TIME_LIMIT_SEC = 30 as const;
/** Экран успеха после победы Tuchi, затем продолжение забега. */
export const TUCHI_VICTORY_HOLD_MS = 3000 as const;
/** Сетка труб Rock: 2 колонки × 3 ряда (как в variants.png). */
export const ROCK_PUZZLE_COLS = 2 as const;
export const ROCK_PUZZLE_ROWS = 3 as const;
export const ROCK_PUZZLE_TILE_COUNT = ROCK_PUZZLE_COLS * ROCK_PUZZLE_ROWS;
/** Лимит времени «Почини трубы» (сек), как в mini-game.svg. */
export const ROCK_PUZZLE_TIME_LIMIT_SEC = 30 as const;
/** Экран успеха после победы, затем продолжение забега. */
export const ROCK_VICTORY_HOLD_MS = 3000 as const;
/** Лимит времени «Сними удачный кадр» (сек), как в mini-game1.svg. */
export const EDDY_LUCKY_SHOT_TIME_LIMIT_SEC = 30 as const;
/** Экран успеха после победы Eddy, затем продолжение забега. */
export const EDDY_VICTORY_HOLD_MS = 3000 as const;
/** Лимит времени «Попади на место!» (сек), как в mini-game5.svg. */
export const VALL_DROP_BOX_TIME_LIMIT_SEC = 30 as const;
/** Экран успеха после победы Vall, затем продолжение забега. */
export const VALL_VICTORY_HOLD_MS = 3000 as const;
/** Лимит времени «Расшифруй слова» (сек), как в mini-game4.svg. */
export const UFO_DECIPHER_TIME_LIMIT_SEC = 30 as const;
/** Экран успеха после победы Уфо, затем продолжение забега. */
export const UFO_VICTORY_HOLD_MS = 3000 as const;

/** Проверка пары карточек (одинаковый pairId). */
export function areCardsMatching(pairIdA: string, pairIdB: string): boolean {
  return pairIdA === pairIdB;
}

/** Сравнить ввод игрока с целевой мелодией (полный match). */
export function isMelodyMatch(target: readonly number[], input: readonly number[]): boolean {
  if (target.length !== input.length) {
    return false;
  }
  return target.every((note, i) => note === input[i]);
}

/** Префикс ввода совпадает с мелодией (ещё не полный match и не ошибка). */
export function isMelodyPrefix(target: readonly number[], input: readonly number[]): boolean {
  if (input.length > target.length) {
    return false;
  }
  return input.every((note, i) => note === target[i]);
}

/** Уфо: выбранный индекс совпадает с верным вариантом перевода. */
export function isUfoAnswerCorrect(
  selectedIndex: number,
  correctIndex: number,
): boolean {
  return selectedIndex === correctIndex;
}

export type RockTileRotation = 0 | 1 | 2 | 3;

export function rotateRockTile(rotation: RockTileRotation): RockTileRotation {
  return ((rotation + 1) % 4) as RockTileRotation;
}

/** Сгенерировать мелодию из нот 1…noteCount длины length. */
export function createMelodySequence(
  length: number = TUCHI_MELODY_LENGTH,
  noteCount: number = TUCHI_NOTE_COUNT,
  random: () => number = Math.random,
): number[] {
  return Array.from({ length }, () => 1 + Math.floor(random() * noteCount));
}
